const firebaseConfig = {
    apiKey: "AIzaSyAS-2TANHDut2hng7Aj5yXyowFcm9_9c9Y",
    authDomain: "genai-f9198.firebaseapp.com",
    projectId: "genai-f9198",
    storageBucket: "genai-f9198.appspot.com",
    messagingSenderId: "1050862449883",
    appId: "1:1050862449883:web:60f2bfc782e9e5ed3688fe",
    measurementId: "G-CBY089B5JT"
  };

  export { firebaseConfig };